import {
    FETCH_FITNESS_AGE_DATA_FETCHING,
    FETCH_FITNESS_AGE_DATA_SUCCESS,
    FETCH_FITNESS_AGE_DATA_FAIL
} from 'actions/ActionTypes';

import { roundFitnessAgeData } from 'utils/fitnessAge/fitnessAgeUtils';

const INITIAL_STATE = {
    fitnessAgeData: null,
    fitnessAgeDataFetching: false,
    fitnessAgeDataSuccess: false,
    fitnessAgeDataFail: false
};

const fitnessAgeDataFetching = (state) => ({
    ...state,
    fitnessAgeDataFetching: true
});

const fitnessAgeDataFetchFinished = (isSuccess) => (state, action) => {
    const roundedFitnessAgeData = roundFitnessAgeData(action.fitnessAgeData);

    return {
        ...state,
        fitnessAgeData: isSuccess ? roundedFitnessAgeData : null,
        fitnessAgeDataFetching: false,
        fitnessAgeDataSuccess: isSuccess,
        fitnessAgeDataFail: !isSuccess
    };
};

export const isFitnessAgeDataFetching = (state) => {
    return state.fitnessAge.fitnessAgeDataFetching;
};

export const isFitnessAgeDataFetchSuccess = (state) => {
    return state.fitnessAge.fitnessAgeDataSuccess;
};

export const isFitnessAgeDataFetchFail = (state) => {
    return state.fitnessAge.fitnessAgeDataFail;
};

export const getFitnessAgeData = (state) => {
    return state.fitnessAge.fitnessAgeData;
};

const handlers = {
    [FETCH_FITNESS_AGE_DATA_FETCHING]: fitnessAgeDataFetching,
    [FETCH_FITNESS_AGE_DATA_SUCCESS]: fitnessAgeDataFetchFinished(true),
    [FETCH_FITNESS_AGE_DATA_FAIL]: fitnessAgeDataFetchFinished(false)
};

export default function fitnessAge(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
